import webBackApi from '../../api/webBackApi';

export const getAllPayments = async () => {
  try {
    const response = await webBackApi.get('/api/payments');
    return response.data;
  } catch (error) {
    console.error("Error fetching payments:", error);
    throw error;
  }
};

export const getCustomerPayments = async (customerId) => {
  try {
    const response = await webBackApi.get(`/api/payments/customer/${customerId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer payments:", error);
    throw error;
  }
};

export const getCustomerPaymentType = async (customerId) => {
  // No console.error here: a customer with no payments yet is an expected,
  // high-frequency case, not an anomaly worth logging.
  const response = await webBackApi.get(`/api/payments/customer/${customerId}/type`);
  return response.data;
};

export const createManualPayment = async (payload) => {
  try {
    const response = await webBackApi.post('/api/payments/manual', payload);
    return response.data;
  } catch (error) {
    console.error("Error creating manual payment:", error);
    throw error;
  }
};
